import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '../../public/images/start_building-round.svg'
import _imports_1 from '../../public/images/error.svg'
import _imports_2 from '../../public/images/check.svg'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "subsida" }
const _hoisted_3 = { class: "company" }
const _hoisted_4 = { class: "company_info" }
const _hoisted_5 = { class: "company_info_name" }
const _hoisted_6 = {
  class: "company_info_number",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = {
  "aria-live": "polite",
  "aria-atomic": "false"
}
const _hoisted_9 = {
  key: 0,
  class: "content"
}
const _hoisted_10 = {
  key: 0,
  class: "errormsg",
  tabindex: "-1",
  role: "alert"
}
const _hoisted_11 = { class: "kvittens-kvitto" }
const _hoisted_12 = { class: "div-positioner" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { "aria-hidden": "true" }
const _hoisted_15 = { class: "sr-only" }
const _hoisted_16 = { class: "kvittens-container" }
const _hoisted_17 = { "aria-hidden": "true" }
const _hoisted_18 = { class: "sr-only" }
const _hoisted_19 = {
  key: 1,
  class: "content",
  id: "svaraanvy"
}
const _hoisted_20 = {
  key: 0,
  class: "errormsg",
  tabindex: "-1",
  role: "alert"
}
const _hoisted_21 = {
  key: 1,
  class: "laddar-container"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 0,
  class: "errormsg",
  role: "alert"
}
const _hoisted_24 = { class: "errormsg_content" }
const _hoisted_25 = { tabindex: "-1" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  class: "globalMessage",
  href: "#stakvar"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  class: "globalMessage",
  href: "#email"
}
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  class: "globalMessage",
  href: "#confirm_email"
}
const _hoisted_32 = { class: "form-container" }
const _hoisted_33 = { class: "form-row" }
const _hoisted_34 = { class: "form-row" }
const _hoisted_35 = { class: "form-row" }
const _hoisted_36 = { class: "form-row" }

import TextInput from '@/components/partials/TextInput.vue';
import CustomCheckbox from '@/components/partials/CustomCheckbox.vue';
import LaddarSymbol from '@/components/partials/LaddarSymbol.vue';

import { ref, onMounted, nextTick } from 'vue'
import { Form } from 'vee-validate';
import * as Yup from 'yup';
import { toUnicode } from 'punycode';

import { useStore } from '@/store';
import { verifieraOchBekrafta } from '@/api';
import { separeraTecken } from "@/format";
import { epostRegex } from '@/validation'
import router from '@/router';

import i18n from "../i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'Svara',
  setup(__props) {

const store = useStore();

const skapaOrgnummertext = (): string => {
	const orgnummer: string = store.state.orgnummerKomplett;
	const idx: number = orgnummer.length - 4;
	return `${orgnummer.slice(0, idx)}-${orgnummer.slice(idx)}`;
}

const skapaA11yKvittensnummer = () : string => {
	return separeraTecken(store.state.kvittensnummer, " ");
}

const zeroPad = (n: number): string => {
	return String(n).padStart(2, "0");
}

const skapaDatumtext = (): string => {
	// Ankomsttid är angivet i sekunder, omvandla till millisekunder
	const datum: Date = new Date(store.state.ankomsttid * 1000);
	const timme: string = zeroPad(datum.getHours());
	const minut: string = zeroPad(datum.getMinutes());
	return `${datum.toLocaleDateString("sv-SV")}, kl. ${timme}.${minut}`;
}

const visaKvittenssida = (): boolean => {
	return store.state.kvittensnummer.length > 0;
}

const visaLaddarSymbol = (): boolean => {
	return store.state.vantarPaResponse;
}

const visaFelmeddelande = (): boolean => {
	return store.state.felmeddelande.length > 0;
}


/* Se till att vi alltid visa något (under utvecklingsfasen) */
const foretagsnamn: string = store.state.foretagsnamn.length > 0 ? store.state.foretagsnamn : "FÖRETAGSNAMN AB";
const organisationsnummer: string = store.state.orgnummerKomplett.length > 0 ? skapaOrgnummertext() : "556677-8899";
const a11yorganisationsnummer: string = separeraTecken(organisationsnummer, " "); // För uppläsning (X X X X X X - X X X X)

const benamning: string = store.state.arForetag ? i18n.global.t("general.the_company") : i18n.global.t("general.the_association");
const checkboxText = i18n.global.t("general.info_texts.remain_in_the_register", { name: benamning });
const epostvalidera: string = i18n.global.t("general.errors.invalid_email");
const repeteraepostvalidera: string = i18n.global.t("general.errors.confirm_email");
const markeraStakvar: string = i18n.global.t("general.errors.confirm_checkbox", { name: benamning.toLowerCase() });

const schema = Yup.object().shape({
	email: Yup
		.string()
		.matches(new RegExp(epostRegex), epostvalidera),
	confirm_email: Yup
		.string()
		.matches(new RegExp(epostRegex), epostvalidera)
		.oneOf([Yup.ref('email')], repeteraepostvalidera),
	stakvar: Yup
		.bool()
        .required(markeraStakvar),
});

const onSubmit = () => {
	// Hantera åäö i epostadress. Vissa webbläsare (Chrome & Edge) encodar non-ASCII till ASCII (punycode).
	// Alternativt måste <input type="email"> bytas till <input type="text">.
	const epost = toUnicode(email.value.trim()); 
	store.state.epost = epost.length > 0 ? epost : null;
	store.state.staKvar = stakvar.checked;
	verifieraOchBekrafta(() => {
		router.push("/kvittens");
	});
};

const onInvalidSubmit = () => {
	const firstEl = document.querySelector('[aria-invalid="true"]');
	if (firstEl) {
		firstEl.focus();
	}	
};

//const filter = ref(null);
const svaraHeader = ref(null)

onMounted(() => {
    nextTick(() => {
		svaraHeader.value.focus();
		console.log(document.activeElement);
    });
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (visaKvittenssida())
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: "title nooutline",
            tabindex: "-1",
            ref_key: "svaraHeader",
            ref: svaraHeader
          }, "Tack för ditt svar!", 512))
        : (_openBlock(), _createElementBlock("h1", {
            key: 1,
            class: "title nooutline",
            tabindex: "-1",
            ref_key: "svaraHeader",
            ref: svaraHeader
          }, _toDisplayString(_ctx.$t("main.title")), 513)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(foretagsnamn)), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(organisationsnummer)), 1),
          _createElementVNode("p", _hoisted_7, "Organisationsnummer, " + _toDisplayString(_unref(a11yorganisationsnummer)), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon" }, [
          _createElementVNode("img", {
            class: "icon_img",
            src: _imports_0,
            alt: "",
            "aria-hidden": "true"
          })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (visaKvittenssida())
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (visaFelmeddelande())
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      class: "errormsg_symbol",
                      width: "32",
                      height: "32",
                      src: _imports_1,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("p", null, _toDisplayString(_unref(store).state.felmeddelande), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "icon-left" }, [
                  _createElementVNode("img", {
                    class: "check-icon",
                    src: _imports_2,
                    alt: ""
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", _hoisted_14, [
                      _cache[2] || (_cache[2] = _createTextVNode(" Bolagsverket har tagit emot ditt svar för ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_unref(foretagsnamn)), 1),
                      _createTextVNode(", " + _toDisplayString(_unref(organisationsnummer)) + ". ", 1)
                    ]),
                    _createElementVNode("p", _hoisted_15, " Bolagsverket har tagit emot ditt svar för " + _toDisplayString(_unref(foretagsnamn)) + ", organisationsnummer " + _toDisplayString(_unref(a11yorganisationsnummer)) + ". ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("dl", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("dt", null, "Datum:", -1)),
                      _createElementVNode("dd", null, _toDisplayString(skapaDatumtext()), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("dt", { "aria-hidden": "true" }, "Kvittensnummer:", -1)),
                      _createElementVNode("dd", _hoisted_17, _toDisplayString(_unref(store).state.kvittensnummer), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("dt", { class: "sr-only" }, "Kvittensnummer:", -1)),
                      _createElementVNode("dd", _hoisted_18, _toDisplayString(skapaA11yKvittensnummer()), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (visaFelmeddelande())
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                      class: "errormsg_symbol",
                      width: "32",
                      height: "32",
                      src: _imports_1,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("p", null, _toDisplayString(_unref(store).state.felmeddelande), 1)
                  ]))
                : _createCommentVNode("", true),
              (visaLaddarSymbol())
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(LaddarSymbol)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_unref(Form), {
                      onSubmit: onSubmit,
                      "validation-schema": _unref(schema),
                      onInvalidSubmit: onInvalidSubmit
                    }, {
                      default: _withCtx(({ errors }) => [
                        (Object.keys(errors).length != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[8] || (_cache[8] = _createElementVNode("img", {
                                class: "errormsg_symbol",
                                width: "32",
                                height: "32",
                                src: _imports_1,
                                alt: ""
                              }, null, -1)),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("h2", _hoisted_25, [
                                  (Object.keys(errors).length == 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("general.errors.correct_issue")), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("general.errors.correct_issues", { count: Object.keys(errors).length.toString()})), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("ul", null, [
                                  (errors.stakvar)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                        _createElementVNode("a", _hoisted_27, _toDisplayString(errors.stakvar), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (errors.email)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                        _createElementVNode("a", _hoisted_29, _toDisplayString(errors.email), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (errors.confirm_email)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                                        _createElementVNode("a", _hoisted_31, _toDisplayString(errors.confirm_email), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(CustomCheckbox, {
                              id: "stakvar",
                              name: "stakvar",
                              required: true,
                              mode: "passive",
                              label: _unref(checkboxText),
                              class: "light",
                              arialabel: 'Ja, ' + _unref(checkboxText)
                            }, null, 8, ["label", "arialabel"])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("general.info_texts.enter_your_email_address_title")), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t("general.info_texts.enter_your_email_address_text")), 1),
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(TextInput, {
                                id: "email",
                                name: "email",
                                type: "email",
                                required: false,
                                mode: "passive",
                                label: "E-postadress (valfri)",
                                autocomplete: "on",
                                class: "text-black light",
                                "required-pattern": _unref(epostRegex),
                                "default-value": ""
                              }, null, 8, ["required-pattern"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(TextInput, {
                                id: "confirm_email",
                                name: "confirm_email",
                                type: "email",
                                mode: "passive",
                                required: false,
                                class: "text-black light",
                                label: "Bekräfta e-postadress",
                                arialabel: "Bekräfta den epostadress du skrev i fältet innan.",
                                autocomplete: "new-password",
                                "required-pattern": _unref(epostRegex),
                                "default-value": ""
                              }, null, 8, ["required-pattern"])
                            ])
                          ])
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "button-container" }, [
                          _createElementVNode("button", {
                            "aria-label": "Skicka in",
                            class: "next",
                            type: "submit"
                          }, "Skicka in")
                        ], -1))
                      ]),
                      _: 1
                    }, 8, ["validation-schema"])
                  ]))
            ]))
      ])
    ])
  ]))
}
}

})